export const paymentTypesConstants = {
  CASA_ACCOUNT_TYPE: "CASA",
  CARDS_TYPE: "Credit/Debit Card",
};
